export default {
    AuxiliarFiliado: axios.create({
      baseURL: process.env.VUE_APP_ENDPOINT_API + "auxiliar-filiado"
    })
  }


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/AuxiliarFiliado.js
// module id = 3k4/
// module chunks = 16